import { DEFAULT_COLORS } from 'components/core/colors';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  background-color: transparent;
  gap: 8px;
`;

export const CopyrightText = styled.span`
  font-size: 0.75rem;
  color: #6b6b6b;
`;

export const LinksRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const FooterLink = styled.a`
  font-size: 0.75rem;
  color: ${DEFAULT_COLORS.primary};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
